import { LearningProgressDetailPage } from "@/features/learning-progress/pages/LearningProgressDetail";

export default LearningProgressDetailPage;
